import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { nodesToPdf } from '../utils/pdf';
import OEReportsChart from './OEReportsChart';
import MCReportsChart from './MCReportsChart';
import SDReportsChart from './SDReportsChart';
import PPReportsChart from './PPReportsChart';
import ESDReportsChart from './ESDReportsChart';
import SEDReportsChart from './SEDReportsChart';
import '../styles/Reports.scss';

const AllReportsPage = () => {
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const refs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const downloadPDF = async () => {
    setDownloading(true);
    const toolbar = document.querySelector('.all-reports-toolbar');
    try {
      await nodesToPdf(
        refs.map((r) => r.current),
        'bbee-all-reports.pdf',
        {
          beforeCapture: () => { if (toolbar) toolbar.style.visibility = 'hidden'; },
          afterCapture: () => { if (toolbar) toolbar.style.visibility = 'visible'; },
        }
      );
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="all-reports-page">
      <div className="all-reports-toolbar">
        <button className="reports-back" onClick={() => navigate('/')}>← Back</button>
        <button className="reports-back" onClick={downloadPDF} disabled={downloading}>
          {downloading ? 'Generating PDF…' : 'Download All Reports (PDF)'}
        </button>
      </div>
      <div className="all-reports-section" ref={refs[0]}><OEReportsChart /></div>
      <div className="all-reports-section" ref={refs[1]}><MCReportsChart /></div>
      <div className="all-reports-section" ref={refs[2]}><SDReportsChart /></div>
      <div className="all-reports-section" ref={refs[3]}><PPReportsChart /></div>
      <div className="all-reports-section" ref={refs[4]}><ESDReportsChart /></div>
      <div className="all-reports-section" ref={refs[5]}><SEDReportsChart /></div>
      {showScrollTop && (
        <button className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          ↑
        </button>
      )}
    </div>
  );
};

export default AllReportsPage;
